// // src/components/layout/AdminLayout.jsx
// import React, { useState } from 'react';
// import { Outlet, Navigate, useNavigate } from 'react-router-dom';
// import { useAuth } from '../../hooks/useAuth';
// import Sidebar from './Sidebar';
// import { Menu, X, Bell, LogOut } from 'lucide-react';

// const AdminLayout = () => {
//   const { user, loading, logout } = useAuth();
//   const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile toggle
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Desktop collapse
//   const [showLogoutModal, setShowLogoutModal] = useState(false);
//   const navigate = useNavigate();

//   // Show loading spinner while checking auth
//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-amber-50/30 to-gray-50">
//         <div className="flex flex-col items-center gap-4">
//           <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-200 border-t-amber-600"></div>
//           <p className="text-gray-600 font-medium">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   // Redirect to login if not authenticated
//   if (!user) {
//     return <Navigate to="/admin/login" replace />;
//   }

//   // Handle logout
//   const handleLogout = async () => {
//     try {
//       await logout();
//       setShowLogoutModal(false);
//       navigate('/admin/login', { replace: true });
//     } catch (error) {
//       console.error('Logout error:', error);
//       setShowLogoutModal(false);
//       navigate('/admin/login', { replace: true });
//     }
//   };

//   // Toggle sidebar (mobile)
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Close sidebar (mobile)
//   const closeSidebar = () => {
//     setSidebarOpen(false);
//   };

//   // Toggle collapse (desktop)
//   const toggleCollapse = () => {
//     setSidebarCollapsed(!sidebarCollapsed);
//   };

//   return (
//     <div className="flex h-screen bg-gradient-to-br from-gray-50 via-amber-50/20 to-gray-50 overflow-hidden">
//       {/* Sidebar Component with props */}
//       <Sidebar 
//         isOpen={sidebarOpen} 
//         onClose={closeSidebar}
//         isCollapsed={sidebarCollapsed}
//         onToggleCollapse={toggleCollapse}
//       />

//       {/* Main content area */}
//       <div className="flex flex-col flex-1 overflow-hidden">
//         {/* Top bar */}
//         <header className="bg-white/80 backdrop-blur-xl shadow-sm border-b border-gray-200/50 z-30">
//           <div className="px-4 sm:px-6 lg:px-8">
//             <div className="flex justify-between h-16">
//               <div className="flex items-center">
//                 {/* Mobile menu button */}
//                 <button
//                   type="button"
//                   className="lg:hidden p-2 rounded-lg text-gray-400 hover:text-amber-600 hover:bg-amber-50 focus:outline-none focus:ring-2 focus:ring-amber-500 mr-4 transition-all"
//                   onClick={toggleSidebar}
//                 >
//                   <span className="sr-only">
//                     {sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
//                   </span>
//                   {sidebarOpen ? (
//                     <X className="h-6 w-6" />
//                   ) : (
//                     <Menu className="h-6 w-6" />
//                   )}
//                 </button>

//                 {/* Page title */}
//                 <div>
//                   <h1 className="text-xl font-semibold text-gray-900">
//                     Hello, Admin!
//                   </h1>
//                   <p className="text-xs text-gray-500 hidden sm:block">
//                     Welcome to the Dewanta Villas Dashboard
//                   </p>
//                 </div>
//               </div>

//               {/* Right side of top bar */}
//               <div className="flex items-center space-x-3">
//                 {/* Notifications */}
//                 <div className="relative">
//                   <button className="p-2 text-gray-400 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-all">
//                     <span className="sr-only">View notifications</span>
//                     <Bell className="h-5 w-5" />
//                     {/* Notification badge */}
//                     <span className="absolute top-1 right-1 h-4 w-4 bg-red-500 rounded-full flex items-center justify-center border-2 border-white">
//                       <span className="text-xs text-white font-semibold">3</span>
//                     </span>
//                   </button>
//                 </div>

//                 {/* User menu - Clickable for logout */}
//                 <button
//                   onClick={() => setShowLogoutModal(true)}
//                   className="flex items-center space-x-3 hover:bg-amber-50 rounded-lg p-2 transition-all duration-200 border border-transparent hover:border-amber-200"
//                 >
//                   <div className="flex-shrink-0">
//                     <div className="h-9 w-9 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-md">
//                       <span className="text-sm font-semibold text-white">
//                         {user?.name?.charAt(0)?.toUpperCase() || 'A'}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="hidden md:block text-left">
//                     <div className="text-sm font-semibold text-gray-900">
//                       {user?.name || 'Admin'}
//                     </div>
//                     <div className="text-xs text-amber-600 capitalize font-medium">
//                       {user?.role || 'Administrator'}
//                     </div>
//                   </div>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </header>

//         {/* Logout Modal */}
//         {showLogoutModal && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
//             <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all">
//               <div className="p-6">
//                 <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full">
//                   <LogOut className="w-8 h-8 text-amber-600" />
//                 </div>
                
//                 <h3 className="text-xl font-semibold text-gray-900 text-center mb-2">
//                   Logout Confirmation
//                 </h3>
                
//                 <p className="text-gray-600 text-center mb-6">
//                   Are you sure you want to log out of the admin dashboard?
//                 </p>
                
//                 <div className="flex space-x-3">
//                   <button
//                     onClick={() => setShowLogoutModal(false)}
//                     className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl font-medium transition-all duration-200"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleLogout}
//                     className="flex-1 px-4 py-3 text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl"
//                   >
//                     Yes, Logout
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Page content */}
//         <main className="flex-1 overflow-x-hidden overflow-y-auto">
//           <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//             <Outlet />
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;
// src/components/layout/AdminLayout.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Sidebar from './Sidebar';
import NotificationDropdown from './NotificationDropdown';
import { Menu, X, LogOut } from 'lucide-react';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, loading, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const navigate = useNavigate();
  const profileMenuRef = useRef(null);

  // Handle click outside to close profile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showProfileMenu]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-amber-50/30 to-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-200 border-t-amber-600"></div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = async () => {
    try {
      await logout();
      setShowLogoutModal(false);
      navigate('/admin/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      setShowLogoutModal(false);
      navigate('/admin/login', { replace: true });
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const toggleCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 via-amber-50/20 to-gray-50 overflow-hidden">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={closeSidebar}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={toggleCollapse}
      />

      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Top bar */}
        <header className="bg-white/80 backdrop-blur-xl shadow-sm border-b border-gray-200/50 z-30">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex items-center">
                <button
                  type="button"
                  className="lg:hidden p-2 rounded-lg text-gray-400 hover:text-amber-600 hover:bg-amber-50 focus:outline-none focus:ring-2 focus:ring-amber-500 mr-4 transition-all"
                  onClick={toggleSidebar}
                >
                  <span className="sr-only">
                    {sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                  </span>
                  {sidebarOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>

                <div>
                  <h1 className="text-xl font-semibold text-gray-900">
                    Hello, Admin!
                  </h1>
                  <p className="text-xs text-gray-500 hidden sm:block">
                    Welcome to the Dewanta Villas Dashboard
                  </p>
                </div>
              </div>

              {/* Right side of top bar */}
              <div className="flex items-center space-x-3">
                {/* Notification Dropdown */}
                <NotificationDropdown />

                {/* User menu */}
                <div className="relative" ref={profileMenuRef}>
                  <button
                    onClick={() => setShowProfileMenu(!showProfileMenu)}
                    className="flex items-center space-x-3 hover:bg-amber-50 rounded-lg p-2 transition-all duration-200 border border-transparent hover:border-amber-200"
                  >
                    <div className="flex-shrink-0">
                      <div className="h-9 w-9 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-md">
                        <span className="text-sm font-semibold text-white">
                          {user?.name?.charAt(0)?.toUpperCase() || 'A'}
                        </span>
                      </div>
                    </div>
                    <div className="hidden md:block text-left">
                      <div className="text-sm font-semibold text-gray-900">
                        {user?.name || 'Admin'}
                      </div>
                      <div className="text-xs text-amber-600 capitalize font-medium">
                        {user?.role || 'Administrator'}
                      </div>
                    </div>
                  </button>

                  {/* Profile Dropdown Menu */}
                  {showProfileMenu && (
                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-200 py-2 z-50 profile-dropdown">
                      {/* User Info Section */}
                      <div className="px-4 py-3 border-b border-gray-200">
                        <p className="text-sm font-semibold text-gray-900">
                          {user?.name || 'Admin'}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">
                          {user?.email || 'admin@dewantavillas.com'}
                        </p>
                        <p className="text-xs text-amber-600 capitalize font-medium mt-1">
                          {user?.role || 'Administrator'}
                        </p>
                      </div>

                      {/* Logout Button */}
                      <div className="px-2 py-2">
                        <button
                          onClick={() => {
                            setShowProfileMenu(false);
                            setShowLogoutModal(true);
                          }}
                          className="w-full flex items-center space-x-3 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
                        >
                          <LogOut className="h-4 w-4" />
                          <span className="text-sm font-medium">Logout</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Logout Modal */}
        {showLogoutModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all logout-modal">
              <div className="p-6">
                <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full">
                  <LogOut className="w-8 h-8 text-amber-600" />
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 text-center mb-2">
                  Logout Confirmation
                </h3>
                
                <p className="text-gray-600 text-center mb-6">
                  Are you sure you want to log out of the admin dashboard?
                </p>
                
                <div className="flex space-x-3">
                  <button
                    onClick={() => setShowLogoutModal(false)}
                    className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl font-medium transition-all duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleLogout}
                    className="flex-1 px-4 py-3 text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl"
                  >
                    Yes, Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Page content */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto">
          <div className="max-w-9xl mx-auto px-2 sm:px-4 lg:px-6 py-4">
            
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;